package macha.sh.kotlin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import com.varabyte.kobweb.compose.css.BoxSizing
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.boxSizing
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.core.App
import com.varabyte.kobweb.silk.SilkApp
import com.varabyte.kobweb.silk.components.layout.Surface
import com.varabyte.kobweb.silk.init.InitSilk
import com.varabyte.kobweb.silk.init.InitSilkContext
import com.varabyte.kobweb.silk.init.registerStyleBase
import com.varabyte.kobweb.silk.style.common.SmoothColorStyle
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import kotlinx.browser.document
import kotlinx.browser.window
import macha.sh.kotlin.integrations.POWER_GLITCH_READY_EVENT
import org.w3c.dom.CustomEvent
import org.w3c.dom.HTMLLinkElement
import org.w3c.dom.HTMLScriptElement
import org.jetbrains.compose.web.css.px
@InitSilk
fun initColorMode(ctx: InitSilkContext) {
    ctx.config.initialColorMode = ColorMode.DARK
}

@InitSilk
fun initStyles(ctx: InitSilkContext) {
    ctx.stylesheet.apply {
        registerStyleBase("html, body") { Modifier.fillMaxHeight() }
        registerStyleBase("*, *::before, *::after") { Modifier.boxSizing(BoxSizing.BorderBox) }
        registerStyleBase("body") { Modifier.margin(0.px) }
    }
}

@App
@Composable
fun AppEntry(content: @Composable () -> Unit) {
    LaunchedEffect(Unit) {
        val head = document.head
        val link = (document.createElement("link") as? HTMLLinkElement)?.apply {
            rel = "stylesheet"
            href = "/fonts/fonts.css"
        }
        if (link != null && head?.querySelector("link[href='/fonts/fonts.css']") == null) {
            head?.appendChild(link)
        }

        val iconLink = (document.createElement("link") as? HTMLLinkElement)?.apply {
            rel = "icon"
            type = "image/png"
            href = "/favicon.png"
        }
        if (iconLink != null && head?.querySelector("link[href='/favicon.png']") == null) {
            head?.appendChild(iconLink)
        }

        val appleIcon = (document.createElement("link") as? HTMLLinkElement)?.apply {
            rel = "apple-touch-icon"
            href = "/apple-touch-icon.png"
        }
        if (appleIcon != null && head?.querySelector("link[href='/apple-touch-icon.png']") == null) {
            head?.appendChild(appleIcon)
        }

        fun ensureScript(src: String, defer: Boolean = true, async: Boolean = false, onLoad: (() -> Unit)? = null) {
            val existing = head?.querySelector("script[src='${'$'}src']") as? HTMLScriptElement
            if (existing != null) {
                onLoad?.let { callback ->
                    if (window.asDynamic().PowerGlitch != js("undefined")) {
                        callback()
                    } else {
                        existing.addEventListener("load", { callback() })
                    }
                }
                return
            }
            val script = (document.createElement("script") as? HTMLScriptElement)?.apply {
                this.src = src
                this.defer = defer
                this.async = async
                onLoad?.let { callback ->
                    addEventListener("load", { callback() })
                }
            }
            if (script != null) {
                head?.appendChild(script)
            }
        }

        val isAutomatedBrowser = (window.navigator.asDynamic().webdriver as? Boolean) == true
        if (!isAutomatedBrowser && !window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
            ensureScript(
                "https://cdn.jsdelivr.net/npm/powerglitch@2.3.3/dist/powerglitch.min.js",
                defer = false,
                async = false
            ) {
                window.dispatchEvent(CustomEvent(POWER_GLITCH_READY_EVENT))
            }
        }
    }

    SilkApp {
        Surface(SmoothColorStyle.toModifier().fillMaxHeight()) {
            content()
        }
    }
}
